// ==========================================
// Modal de Cupom de Desconto
// ==========================================

const ModalCupom = {
  elements: {},
  settings: {
    delayMs: 5000, // 5 segundos
    storageKey: 'modalCupomClosedAt',
    storageExpireHours: 24, // Não mostrar novamente por 24 horas
  },

  init: function () {
    this.cacheElements();
    
    if (!this.elements.modal) {
      console.warn('Modal de cupom não encontrado no DOM');
      return;
    }

    // Verifica se o modal já foi fechado recentemente
    if (this.hasRecentlyClosed()) {
      return;
    }

    this.attachEventListeners();
    this.scheduleModalOpen();
  },

  cacheElements: function () {
    this.elements = {
      modal: document.getElementById('modalCupom'),
      overlay: document.getElementById('modalCupomOverlay'),
      closeBtn: document.getElementById('modalCupomClose'),
      copyBtn: document.getElementById('cupomCopyBtn'),
      cupomCode: document.getElementById('cupomCode'),
      ctaButton: document.getElementById('cupomCtaButton'),
    };
  },

  attachEventListeners: function () {
    // Fechar ao clicar no botão X
    this.elements.closeBtn?.addEventListener('click', () => this.closeModal());

    // Fechar ao clicar no overlay
    this.elements.overlay?.addEventListener('click', () => this.closeModal());

    // Copiar código ao clicar no botão de copiar
    this.elements.copyBtn?.addEventListener('click', () => this.copyCode());

    // Fechar ao clicar em "Ir ao Carrinho"
    this.elements.ctaButton?.addEventListener('click', () => this.handleCtaClick());

    // Fechar com ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.elements.modal?.classList.contains('active')) {
        this.closeModal();
      }
    });
  },

  scheduleModalOpen: function () {
    setTimeout(() => {
      this.openModal();
    }, this.settings.delayMs);
  },

  openModal: function () {
    if (!this.elements.modal) return;
    
    this.elements.modal.classList.add('active');
    document.body.style.overflow = 'hidden'; // Evita scroll ao fundo

    console.log('Modal de cupom aberto');
  },

  closeModal: function () {
    if (!this.elements.modal) return;
    
    this.elements.modal.classList.remove('active');
    document.body.style.overflow = ''; // Restaura scroll

    // Armazena que o modal foi fechado
    this.saveClosedTimestamp();

    console.log('Modal de cupom fechado');
  },

  copyCode: function () {
    const code = this.elements.cupomCode?.textContent;
    
    if (!code) {
      console.error('Código do cupom não encontrado');
      return;
    }

    // Copia para o clipboard
    navigator.clipboard.writeText(code.trim()).then(() => {
      // Feedback visual
      this.showCopyFeedback();
      
      // Muda a cor do ícone temporariamente
      this.elements.copyBtn?.classList.add('copied');
      setTimeout(() => {
        this.elements.copyBtn?.classList.remove('copied');
      }, 2000);

      console.log('Cupom copiado:', code);
    }).catch((err) => {
      console.error('Erro ao copiar cupom:', err);
      // Fallback para navegadores antigos
      this.copyCodeFallback(code);
    });
  },

  copyCodeFallback: function (code) {
    // Fallback para navegadores sem suporte a Clipboard API
    const textarea = document.createElement('textarea');
    textarea.value = code.trim();
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);

    this.showCopyFeedback();
    console.log('Cupom copiado (fallback):', code);
  },

  showCopyFeedback: function () {
    // Remove toast anterior se existir
    const existingToast = document.querySelector('.cupom-toast');
    if (existingToast) {
      existingToast.remove();
    }

    // Cria novo toast
    const toast = document.createElement('div');
    toast.className = 'cupom-toast';
    toast.textContent = '✓ Código copiado com sucesso!';
    document.body.appendChild(toast);

    // Remove após 3 segundos
    setTimeout(() => {
      toast.remove();
    }, 3000);
  },

  handleCtaClick: function () {
    // Aqui você pode navegar para o carrinho se desejar
    // window.location.href = '/carrinho';
    this.closeModal();
  },

  saveClosedTimestamp: function () {
    const now = new Date().getTime();
    localStorage.setItem(this.settings.storageKey, now.toString());
  },

  hasRecentlyClosed: function () {
    const lastClosed = localStorage.getItem(this.settings.storageKey);
    
    if (!lastClosed) {
      return false;
    }

    const lastClosedTime = parseInt(lastClosed, 10);
    const now = new Date().getTime();
    const hoursPassed = (now - lastClosedTime) / (1000 * 60 * 60);

    return hoursPassed < this.settings.storageExpireHours;
  },

  // Método público para reabrir o modal (útil para testes)
  reset: function () {
    localStorage.removeItem(this.settings.storageKey);
    this.closeModal();
    this.init();
  },
};

// Inicializa quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    ModalCupom.init();
  });
} else {
  ModalCupom.init();
}

// Expõe globalmente para testes/controle
window.ModalCupom = ModalCupom;
